<script lang="ts" setup>
  import { computed, useId } from 'vue';

  const props = defineProps<{ error?: string }>();
  defineSlots<{ default(field: { 'aria-describedby'?: string; 'aria-invalid'?: 'true' }): unknown }>();

  const errorId = useId();
  const field = computed(() => (props.error ? { 'aria-describedby': errorId, 'aria-invalid': 'true' as const } : {}));
</script>

<template>
  <div class="input-field" :data-invalid="error ? '' : undefined">
    <slot v-bind="field" />
    <p v-if="error" :id="errorId" class="input-field-error">{{ error }}</p>
  </div>
</template>

<style scoped>
  .input-field {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 100%;
  }

  .input-field-error {
    color: var(--color-error);
    font-size: var(--font-size-sm);
    line-height: 1.5;
    margin: 0;
    text-align: center;
  }
</style>
